import React from "react";
import "./ContactUs.css";

const ConnectWithUs = () => {
  const socialLinks = [
    {
      icon: "fab fa-facebook",
      platform: "Facebook",
      handle: "ANW",
      url: "https://www.facebook.com/groups/674888409856155/",
      delay: 100
    },
    {
      icon: "fab fa-instagram",
      platform: "Instagram",
      handle: "@actionnotword",
      url: "https://www.instagram.com/actionnotword/",
      delay: 200
    },
    {
      icon: "fab fa-youtube",
      platform: "YouTube",
      handle: "Action Not Word",
      url: "https://www.youtube.com/channel/UCnZVAnJHv6trhGgp9x_z-Pw",
      delay: 300
    },
    {
      icon: "fas fa-envelope",
      platform: "Email",
      handle: "actionnotword@gmail.com",
      url: "mailto:actionnotword@gmail.com",
      delay: 400
    }
  ];

  return (
    <div className="connectWithUs">
      <h1 data-aos="fade-down" data-aos-delay="100">
        Connect With Us
      </h1>
      
      <div className="socialSection">
        {socialLinks.map((link, index) => (
          <div 
            key={index}
            className="socialIcons" 
            data-aos="zoom-in" 
            data-aos-delay={link.delay}
          >
            <i className={link.icon} />
            <a
              href={link.url}
              target="_blank"
              rel="noreferrer"
            >
              <p>{link.handle}</p>
            </a>
          </div>
        ))}
      </div>

      <div className="map" data-aos="fade-up" data-aos-delay="500">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d212270.5365511358!2d69.0138747!3d34.5260109!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38d16eb6c5e6f4c5%3A0x3e2f3f6c5d3a8b0f!2sKabul%2C%20Afghanistan!5e0!3m2!1sen!2sus!4v1618970744081!5m2!1sen!2sus"
          title="Our Educational Centers in Kabul, Afghanistan"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        />
      </div>
    </div>
  );
};

export default ConnectWithUs;
